import React from "react";
import { IHelloRewardsBannerProps } from "./HelloRewardsBannerProps";
import {
  BackGroundImage,
  Container,
  MobileView,
  TeaserImage,
} from "./HelloRewardsBannerHelpers";
import { row } from "./HelloRewardsBanner.module.scss";
import Row from "../../global/Row/Row";
import Col from "../../global/Col/Col";
import { isMobile } from "react-device-detect";

const HelloRewardsBanner: React.FC<IHelloRewardsBannerProps> = (props) => {
  return (
    <Container>
      <Row className={row}>
        {isMobile ? (
          <Col className={`col6`}>
            <MobileView {...props} />
          </Col>
        ) : (
          <>
            <Col className={`col6`}>
              <BackGroundImage {...props} />
            </Col>
            <Col className={`col6`}>
              <TeaserImage {...props.relationships.field_teaser_image} />
            </Col>{" "}
          </>
        )}
      </Row>
    </Container>
  );
};

export default HelloRewardsBanner;
